import React, { useEffect, useState } from 'react';

import CButton from '../button/button';
import CInput from '../input/input';
import { Line, Space } from '../utils/utils';
import moment from 'moment';

import '../../theme/global.scss';
import styles from '../../pages/monitorization/monitorization.module.scss';
import {
  ILitigation,
  ILitigationDocument
} from '../../utils/interfaces/interfaces';
import { formatDate } from '../../utils/strings';
import CDropdown from '../dropdown/dropdown';
import {
  checkFilesHaveSameType,
  combineFiles,
  fileFormat,
  handleFileChange,
  initialFile
} from '../../utils/files';
import CSwitch from '../switch/switch';
import CUpload from '../input/upload';
import { notify } from '../../notifications/notification';
import { typesFiles } from '../../types/uploaded-data';
import { TermPeriods, types_TermPeriods } from '../../types/litigations';
import {
  addLitigationDocument,
  updateLitigationDocument
} from '../../network/litigii';
import { endOfTerm } from '../../utils/termCalculator';

interface IEditLitigationDocumentProps {
  callback?: () => void;
  litigation: ILitigation;
}

const initialForm: ILitigationDocument = {
  id: 0,
  litigationId: 0,
  name: '',
  document: fileFormat,
  documentCommunicationDate: undefined,
  term: undefined,
  termPeriod: undefined,
  deadline: undefined,
  deadlineConfirmation: undefined
};

const EditLitigationDocument = (props: IEditLitigationDocumentProps) => {
  const [form, updateForm] = useState(initialForm);

  const [termPeriod, setTermPeriod] = useState<
    typeof types_TermPeriods | undefined
  >();
  const [document, setDocument] = useState(initialFile);
  const [selectedDocument, setSelectedDocument] = useState(
    {} as ILitigationDocument
  );
  const [error, setError] = useState('');

  const [submitNew, setTypeSubmit] = useState(false);

  useEffect(() => {
    updateForm(form => ({ ...form, decisionId: props.litigation.id }));
  }, [props.litigation]);

  useEffect(() => {
    if (form.term && form.documentCommunicationDate && form.termPeriod) {
      const date = moment(form.documentCommunicationDate);
      const result = endOfTerm(
        (form.termPeriod as string).toLowerCase(),
        form.termPeriod === TermPeriods.Days ? false : false,
        date,
        form.term
      );
      updateForm(form => ({ ...form, deadline: result.toDate() }));
    }
  }, [form.term, form.documentCommunicationDate, form.termPeriod]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event && event.target) {
      const { value, name } = event.target;
      updateForm(form => ({ ...form, [name]: value }));
    }
  };

  const handleDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    new Date(value) &&
      updateForm(form => ({ ...form, [name]: new Date(value) }));
  };

  const handleTermPeriod = (item: any) => {
    setTermPeriod(item);
    updateForm(form => ({ ...form, termPeriod: item?.key }));
  };

  const handleSelectedDoc = (item: any) => {
    setSelectedDocument(item);
  };

  const handleFile = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFile: any
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      if (!checkFilesHaveSameType(event.target.files, typesFiles.pdf)) {
        notify('Trebuie sa incarcati documente de tip PDF', 'info');
        return;
      }
    }
    handleFileChange(event, setFile);
  };

  const handleSubmit = async (event: React.MouseEvent) => {
    event.preventDefault();
    console.log(form);
    setError('');
    if (
      form.deadlineConfirmation?.toDateString() !==
      form.deadline?.toDateString()
    ) {
      setError('Data limita de depunere trebuie validata corect.');
      return;
    }

    if (form.name === '') {
      setError('Trebuie completat numele.');
      return;
    }

    // setError('Trebuie sa completati toate campurile');

    const decisionDocument = await combineFiles(document, form.name);

    if (!submitNew && Object.keys(document).length === 0) {
      addLitigationDocument({
        ...form,
        litigationId: props.litigation.id,
        document: decisionDocument
      }).then(() => {
        notify('Ati salvat documentul', 'success');
        props.callback && props.callback();
      });

      return;
    }

    if (submitNew) {
      if (Object.keys(document).length === 0) {
        setError('Trebuie sa incarcati un document');
        return;
      }

      addLitigationDocument({
        ...form,
        litigationId: props.litigation.id,
        document: decisionDocument
      }).then(() => {
        notify('Ati salvat documentul', 'success');
        props.callback && props.callback();
      });

      return;
    } else {
      if (Object.keys(selectedDocument).length === 0) {
        //setError('Trebuie sa selectati un document');
        //return;
      }

      updateLitigationDocument({
        ...form,
        id: selectedDocument.id,
        litigationId: props.litigation.id
      }).then(() => {
        notify('Ati submis cu succes actiunea', 'success');
        props.callback && props.callback();
      });

      return;
    }
  };

  return (
    <form>
      <p className='body-dark bold'>Adaugare act de procedura</p>
      <Line width={'80px'} />
      <Space vertical={'30px'} />
      {error && <p className='body-dark error'>{error}</p>}
      <Space vertical={'30px'} />
      <CInput
        label='Data comunicării actului de procedura'
        type='date'
        id='documentCommunicationDate'
        // placeholder='prolongedDeadline'
        name='documentCommunicationDate'
        value={
          form.documentCommunicationDate
            ? formatDate(form.documentCommunicationDate)
            : undefined
        }
        onChange={handleDate}
        required
      />
      <CInput
        label='Termen'
        type='number'
        id='term'
        placeholder='Termen'
        name='term'
        value={form.term?.toString()}
        onChange={handleChange}
        inputmode='numeric'
        onKeyPress={(event: any) => {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        }}
        required
      />
      <CDropdown
        label='Perioada'
        placeholder=''
        visibleKey='name'
        currentOption={termPeriod}
        onChange={handleTermPeriod}
        list={types_TermPeriods}
        className={styles.dropdownStatuses}
        viewOnly
      />
      <CInput
        label='Dată limita de depunere'
        type='date'
        id='deadline'
        name='deadline'
        value={form.deadline ? formatDate(form.deadline) : undefined}
        onChange={handleDate}
        required
        disabled
      />
      <CInput
        label='Validare data limita'
        type='date'
        id='deadlineConfirmation'
        name='deadlineConfirmation'
        value={
          form.deadlineConfirmation
            ? formatDate(form.deadlineConfirmation)
            : undefined
        }
        onChange={handleDate}
        required
      />
      <CInput
        label='Nume document'
        type='text'
        id='name'
        placeholder='Numele documentului'
        name='name'
        value={form.name}
        onChange={handleChange}
        required
      />
      <CSwitch
        value={submitNew}
        label={'Doriți să încărcați un document nou?'}
        onChecked={() => setTypeSubmit(!submitNew)}
      />
      {!submitNew && (
        <CDropdown
          label='Document'
          placeholder='Alegeți un document'
          visiblePhrase={el => (el ? `${el.name}` : '')}
          currentOption={selectedDocument}
          onChange={handleSelectedDoc}
          list={props.litigation.documents}
          className={styles.dropdownStatuses}
        />
      )}
      {submitNew && (
        <>
          <CUpload
            label='Încărcați documentul'
            title='Încărcați documentul'
            id='document'
            name=''
            value={document}
            onChange={e => handleFile(e, setDocument)}
          />
        </>
      )}

      <Space vertical={'30px'} />
      <CButton label='Salveaza' type='submit' onClick={handleSubmit} />
    </form>
  );
};

export default EditLitigationDocument;
